import React from "react";

export const Form = (props) => {
  return (
    <div>
      <input
        type={props.Itype}
        name={props.Iname}
        placeholder={props.IplaceH}
        className="form_control"
      />
      <span className="Formicon">{props.Iicon}</span>
    </div>
  );
};
